import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconReportsIconOld} from 'shells/icon/svg/sidebar-icon-reports-old';

import {useDismissibleUserSetting} from '../../../../util/hooks/use-dismissible-user-setting';

export function TemplateGroupsEmailReportCta() {
    const {shouldShow, onDismiss} = useDismissibleUserSetting(
        'hide_email_report_via_template_groups'
    );

    if (shouldShow) {
        return (
            <CTABanner
                icon={SidebarIconReportsIconOld}
                title='Email template reporting is here!'
                text='See what kind of emails your team is sending with our new email report'
                buttonText='Take me there!'
                href='/reports/email'
                newTab={true}
                onDismiss={onDismiss}
            />
        );
    }

    return null;
}
